(() => {
  const product = document.querySelector('[data-anya-product]');
  // Bouton fixe mobile : vers le configurateur de la page (produit, accueil), sinon vers l'action d'achat des pages de contenu.
  const builderSelector = '[data-pack-builder],[data-offer-builder]';
  const builder = product?.querySelector(builderSelector) || document.querySelector(builderSelector);
  const pageAction = document.querySelector('.anya-section-action__button');
  if (builder || pageAction) {
    const link = document.createElement('a');
    link.href = builder ? '#packs' : pageAction.getAttribute('href').trim();
    link.className = 'anya-mobile-return';
    link.textContent = product?.querySelector('[data-mobile-label]')?.textContent || pageAction?.textContent;
    link.hidden = true;
    document.body.append(link);
    const watched = [builder, ...document.querySelectorAll('.anya-section-action__button')].filter(Boolean);
    const onScreen = new Set();
    const sync = () => {
      const dialogOpen = [...document.querySelectorAll('[role="dialog"],dialog[open]')].some(dialog => dialog.getClientRects().length && getComputedStyle(dialog).visibility !== 'hidden');
      const beforeFold = !product && window.scrollY < window.innerHeight * 0.8;
      link.hidden = onScreen.size > 0 || beforeFold || /INPUT|TEXTAREA|SELECT/.test(document.activeElement?.tagName) || dialogOpen;
    };
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => entry.isIntersecting ? onScreen.add(entry.target) : onScreen.delete(entry.target));
      sync();
    });
    watched.forEach(element => observer.observe(element));
    document.addEventListener('focusin', sync);
    document.addEventListener('focusout', () => requestAnimationFrame(sync));
    window.addEventListener('scroll', sync, {passive:true});
    new MutationObserver(sync).observe(document.body, {childList:true,subtree:true});
    document.addEventListener('click',()=>requestAnimationFrame(sync));
    // Sur une fiche produit, les liens vers ce même produit mènent directement au configurateur.
    const productPath = product?.dataset.productUrl;
    if (product && productPath) {
      document.querySelectorAll('a[href]').forEach(a => {
        const target = a.getAttribute('href');
        if (target.includes(productPath) || target.endsWith('#packs')) a.setAttribute('href', '#packs');
      });
    }
  }
  // Vidéos sans préchargement : quand elles approchent de l'écran, on charge seulement leurs métadonnées
  // et on affiche une image prise à 0,5 s, au lieu d'une miniature noire (fondu d'ouverture).
  const lazyVideos = [...document.querySelectorAll('video[preload="none"]')];
  if (lazyVideos.length && 'IntersectionObserver' in window) {
    const previewObserver = new IntersectionObserver(entries => entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      const video = entry.target;
      previewObserver.unobserve(video);
      video.addEventListener('loadedmetadata', () => {
        if (video.paused && video.currentTime === 0) video.currentTime = Math.min(0.5, (video.duration || 1) / 2);
      }, {once: true});
      video.preload = 'metadata';
      video.load();
    }), {rootMargin: '200px'});
    lazyVideos.forEach(video => previewObserver.observe(video));
  }
  document.addEventListener('play', event => {
    if (event.target.tagName !== 'VIDEO') return;
    document.querySelectorAll('video').forEach(video => { if (video !== event.target) video.pause(); });
  }, true);
  const language = document.querySelector('#anya-lang-select');
  language?.addEventListener('change', () => {
    const input = language.form.querySelector('[name="return_to"]');
    if (input) input.value = location.pathname + location.search + location.hash;
  },true);
  // Sous-menus de l'en-tête : un seul ouvert à la fois, fermés par un clic ailleurs ou Échap.
  const groups = [...document.querySelectorAll('.anya-header__menu .anya-nav-group')];
  groups.forEach(group => group.addEventListener('toggle', () => {
    if (group.open) groups.forEach(other => { if (other !== group) other.open = false; });
  }));
  document.addEventListener('click', event => groups.forEach(group => { if (group.open && !group.contains(event.target)) group.open = false; }));
  document.addEventListener('keydown', event => { if (event.key === 'Escape') groups.forEach(group => { group.open = false; }); });
})();
